import { CustomCheckBox } from './component'

export default CustomCheckBox



// WEBPACK FOOTER //
// ./src/components/CustomCheckBox/index.js